import { css } from 'linaria';

export const AdBlock = css`
  display: flex;
  flex-direction: column;
  min-width: 240px;
  color: #fff;
`;
